import axios from "axios";
import { useEffect, useState } from "react";
import { AiFillPlusCircle } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router";
import OutlinedButton from "../../components/Common/Buttons/OutlinedButton";
import AntdBreadcrumbs from "../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import FilledButton from "../../components/Common/Buttons/FilledButton";
import NavBarTitles from "../../components/Common/TabBar";
import "./faq.scss";

const FaqBanner = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [faqSections, setFaqsections] = useState([]);
  const addNewFaqs = {
    id: "addnewpost",
    onClick: () => navigate(`/faq/${location.pathname.split("/")[2]}/add-faq`),
    style: { width: "240px" },
    label: "Add New FAQ's",
  };
  const addNewFaqSection = {
    prefix: true,
    className: "addNewFaqSection",
    icon: <AiFillPlusCircle color="#4E91C2" size={25} />,
    onClick: () => navigate("/faq/add-faq-section"),
    style: { width: "240px" },
    label: "Add New FAQ Section",
  };
  const currentSlug = location.pathname.split("/")[2];

  const fetchPlatforms = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}faq-section/list`,
      );
      setFaqsections(res.data.rows || []);
    } catch (err) {
      console.error("Failed to fetch faqSection names", err);
    }
  };

  useEffect(() => {
    fetchPlatforms();
  }, [currentSlug]);

  const breadcrumbsList = [
    { text: "FAQ's", link: "" },
    {
      text:
        faqSections.find((data) => data?.slugurl === currentSlug)?.name || "",
      link: "",
    },
  ];

  const tabs = faqSections.map((item) => ({
    name: item.name,
    navigatePath: `/faq/${item?.slugurl}`,
  }));

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <AntdBreadcrumbs
          className="healthsyMasterBreadCrumbs pb-2"
          breadcrumbsList={breadcrumbsList}
        />
        <div className="d-flex align-items-center">
          <FilledButton props={addNewFaqs} />
          <OutlinedButton props={addNewFaqSection} />
        </div>
      </div>
      <div className="my-3">
        <NavBarTitles titles={tabs} />
      </div>
    </>
  );
};

export default FaqBanner;
